export default __webpack_public_path__ + "static/media/banner-6.34ca929c.jpg";